import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("SECTION CRASH:", error, info?.componentStack);
  }
  render() {
    if (this.state.error) {
      return (
        <div data-testid="error-boundary" style={{ padding: 24, fontFamily: "monospace", color: "#b00", background: "#fff", whiteSpace: "pre-wrap" }}>
          {"CRASH: " + (this.state.error?.message || String(this.state.error)) + "\n\n" + (this.state.error?.stack || "")}
        </div>
      );
    }
    return this.props.children;
  }
}
